export default __webpack_public_path__ + "static/thermal-0ea136d3f2db77e6b0df39f34dcf8c98.jpg";